import type { GetAuthUserByIdWithRolesResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetAuthUserByIdWithRolesQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAuthUserByIdWithRolesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetAuthUserByIdWithRolesArgs = {
  id: string;
};

const mapTrpcUserToGraphQL = (
  user: GetAuthUserByIdWithRolesResponseRow
): NonNullable<GetAuthUserByIdWithRolesQuery['auth_user_by_pk']> => ({
  ...user,
  customRoles: (user.customRoles ?? [])
    .filter((customRole) => customRole.customRole != null)
    .map((customRole) => ({ ...customRole, role: customRole.customRole! })),
});

export const useGetAuthUserByIdWithRoles = createQueryHook<
  UseGetAuthUserByIdWithRolesArgs,
  GetAuthUserByIdWithRolesResponseRow[],
  GetAuthUserByIdWithRolesQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.user.userByIdWithRoles.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({
    auth_user_by_pk: data[0] ? mapTrpcUserToGraphQL(data[0]) : null,
  }),
  graphqlDocument: GetAuthUserByIdWithRolesDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
